import styled, { css } from "styled-components"
import { Link } from "gatsby"

export const Container = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 75px;
  background: var(--clr-purple);
  font-weight: bold;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;
  z-index: 5;
  padding: 0 15px;

  .nav__logo-container {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    align-items: center;
    min-width: 40px;
    min-height: 40px;
    max-width: 60px;
    max-height: 60px;
    margin-right: var(--gapM);

    svg {
      width: 100%;
      height: 100%;
    }

    @media (max-width: 992px) {
      margin: 0;
      width: 40px;
    }
  }

  @media (max-width: 992px) {
    height: 50px;
  }
`

export const MainList = styled.ul`
  width: 100%;
  max-width: 1000px;
  height: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  justify-content: space-between;
  color: white;
  li {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    justify-content: center;
    cursor: pointer;

    & a,
    button {
      width: 120px;
      padding: 7.5px 5px;
      text-align: center;
      border-radius: var(--border-radius);
    }

    & a:hover,
    & a:focus,
    & button:hover,
    & button:focus {
      background: white;
      color: var(--clr-purple);
    }
  }

  @media (max-width: 992px) {
    display: none;
    visibility: hidden;
  }
`

export const GatsbyLink = styled(Link)`
  ${props =>
    props.active
      ? `
    background: white;
    color: var(--clr-purple);
`
      : ""}
`

export const LeistungenButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-weight: bold;

  ${props =>
    props.active
      ? `
    background: white;
    color: var(--clr-purple);
`
      : ""}
`

export const Button = styled.button`
  z-index: 12;
  background: none;
  color: white;
  border: none;
  order: 1;
  position: relative;
  display: none;
  visibility: hidden;

  @media (max-width: 992px) {
    display: block;
    visibility: visible;
  }

  span {
    display: inline-block;
    padding: 5px;
  }

  ${props =>
    props.visible
      ? css`
          span:nth-child(2) {
            visibility: hidden;
            outline: none;
          }
        `
      : css`
          ${HamburgerMenuItems} {
            visibility: hidden;
            outline: none;
          }
        `}
`

export const HamburgerMenuItems = styled.span`
  display: inline-block;
  position: absolute;
  background: rgba(0, 0, 0, 0);
  width: 35px;
  height: 35px;
  z-index: 11;
  right: 0;

  &:after,
  &:before {
    content: "";
    width: 35px;
    height: 3px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    position: absolute;
    background: white;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  &:before {
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  &:after {
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`

export const Submenu = styled.ul`
  display: none;
  visibility: hidden;
  position: absolute;
  top: 45px;
  padding: 15px;
  border-radius: var(--border-radius);
  background: var(--clr-purple);
  box-shadow: var(--box-shadow);
  color: white;

  li {
    margin-bottom: 5px;

    & a {
      min-width: 185px;
      text-align: left;
      border-radius: var(--border-radius);
    }

    & a:hover,
    & a:focus {
      background: white;
    }

    & :last-child {
      margin-bottom: 0;
    }
  }

  ${props =>
    props.show
      ? css`
          display: block;
          visibility: visible;
        `
      : ""}

  ${props =>
    props.bigger
      ? css`
          li a {
            width: 250px;
            margin-bottom: 15px;
          }
        `
      : ""}
`

export const KontaktIconWrapper = styled.div`
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;

  ${Submenu} {
    right: 0;
    top: 45px;

    li {
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: flex;
      -webkit-box-pack: start;
      -webkit-justify-content: flex-start;
      -moz-box-pack: start;
      justify-content: flex-start;
      margin-left: var(--gapXS);

      & a {
        border-bottom: 2px solid transparent;
      }

      & a:hover,
      & a:focus {
        border-color: var(--clr-purple);
      }
    }

    @media (max-width: 992px) {
      right: -115px;
    }
  }
`

export const KontaktButton = styled.button`
  min-width: 40px;
  min-height: 40px;
  margin-left: var(--gapM);
  cursor: pointer;
  background: none;
  border: none;

  @media (max-width: 992px) {
    width: 40px;
    margin: 0;
  }
`

export const KontaktIcon = styled.div`
  min-width: 25px;
  min-height: 25px;
  max-width: 25px;
  max-height: 25px;
  position: relative;
  margin-right: var(--gapXS);
  pointer-events: none;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
`
